var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"content-element animated fadeIn"},[_c('b-col',{staticStyle:{"padding":"0"}},[_c('div',{staticClass:"dv-separator"})]),_c('options-element',{attrs:{"index-element":_vm.idElement,"index-column":_vm.idColumn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }